let apiBaseUrl: string | null = null;

export function configureApi(opts: { baseUrl: string }): void {
  apiBaseUrl = opts.baseUrl;
}

export class ApiError extends Error {
  status: number;
  body: unknown;
  constructor(status: number, message: string, body: unknown) {
    super(message);
    this.status = status;
    this.body = body;
  }
}

export class TierRequiredError extends Error {
  feature: string;
  constructor(feature: string) {
    super("This feature requires Pro.");
    this.name = "TierRequiredError";
    this.feature = feature;
  }
}

type TokenProvider = () => Promise<string | null>;

let tokenProvider: TokenProvider = async () => null;

export function setTokenProvider(provider: TokenProvider): void {
  tokenProvider = provider;
}

export async function apiFetch<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  if (apiBaseUrl === null) {
    throw new Error("configureApi() must be called before apiFetch()");
  }
  const url = `${apiBaseUrl}${path}`;
  const headers = new Headers(init.headers ?? {});
  if (!headers.has("Accept")) headers.set("Accept", "application/json");
  if (init.body && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  const token = await tokenProvider();
  if (token) headers.set("Authorization", `Bearer ${token}`);

  const res = await fetch(url, { ...init, headers });
  const text = await res.text();
  let body: unknown = null;
  if (text) {
    try {
      body = JSON.parse(text);
    } catch {
      body = text;
    }
  }
  if (!res.ok) {
    if (
      res.status === 403 &&
      typeof body === "object" &&
      body !== null &&
      "detail" in body &&
      typeof (body as { detail: unknown }).detail === "object" &&
      (body as { detail: { code?: unknown } }).detail !== null &&
      (body as { detail: { code?: unknown } }).detail.code === "tier_required"
    ) {
      const detail = (body as { detail: { feature?: unknown } }).detail;
      throw new TierRequiredError(String(detail.feature ?? ""));
    }
    const msg =
      (typeof body === "object" && body && "detail" in body && typeof (body as { detail: unknown }).detail === "string"
        ? ((body as { detail: string }).detail)
        : null) ?? res.statusText;
    throw new ApiError(res.status, msg, body);
  }
  return body as T;
}
